import React from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import { useDarkMode } from '../../context/DarkModeContext';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  onSearchChange,
  placeholder = 'Search...'
}) => {
  const { darkMode } = useDarkMode();

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <IoSearchOutline
          className={`h-5 w-5 ${
            darkMode ? 'text-gray-400' : 'text-gray-500'
          }`}
          aria-hidden="true"
        />
      </div>
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className={`block w-full pl-10 pr-3 py-2 border rounded-lg ${
          darkMode
            ? 'bg-gray-800 border-gray-700 text-white placeholder-gray-400 focus:border-blue-500'
            : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500 focus:border-blue-500'
        } focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm transition-colors`}
        placeholder={placeholder}
        aria-label="Search"
      />
    </div>
  );
};

export default SearchBar; 